import React, { useEffect, useState } from "react";
import CommonTitle from "../../../components/CommonTitle";
import purpleFlower from "../../../assets/icons/purpleFlower.webp";
import { useNavigate, useParams } from "react-router-dom";
import Select from "../../../components/panel/Select";
import TableStructure from "../../../components/TableScruture";
import BlockInfoTable from "../../../components/panel/BlockInfoTable";
import Filters from "../../../components/Filters";
import FilterItem from "../../../components/FilterItem";
import {
  getSeasonByNumber,
  getSeasonByNumberFiltered,
  getSeasons,
  getSeasonsWithoutLimit,
  saveSeason,
} from "../../../services/seasons";
import ModalStructure from "../../../components/ModalStructure";
import { IS_LOCAL_ENV } from "../../../App";
import Notification from "../../../components/ui-elements/Notification";
import LoadingPage from "../../../components/LoadingPage";

const Programs = () => {
  const navigate = useNavigate();
  const { seasonNumber } = useParams();
  const [loadingFilter, setLoadingFilter] = useState(true);
  const [seasonNumberState, setSeasonNumberState] = useState(null);
  const [seasonInfo, setSeasonInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [seasonOptions, setSeasonOptions] = useState([]);
  const [totalSeasons, setTotalSeasons] = useState(null); // Estado para almacenar el número total de temporadas
  const [showModal, setShowModal] = useState(false);
  const [saving, setSaving] = useState(false);
  const [fromDate, setFromDate] = useState(null);
  const [updCount, setUpdCount] = useState(0);

  //==========================filters=================================
  const [selectPropsList, setSelectPropsList] = useState([
    {
      isInput: true,
      title: "Desde",
      value: "",
      onChange: (e) => updateSelectProp(0, e),
      inputType: "date",
      formatedValue: (val) => new Date(val).toISOString().split("T")[0],
      dbField: "date",
    },
  ]);

  const updateSelectProp = (i, e) => {
    setSelectPropsList((prev) => {
      let temp = [...prev];
      temp[i].value = e.target.value;
      return temp;
    });
  };

  //const [filterQueryObject, setFilterQueryObject] = useState({}); //no se usa en este componente

  //====================================================================

  useEffect(() => {
    setSeasonNumberState(seasonNumber || 1);
    setSeasonInfo(null);
  }, [seasonNumber]);

  // ========================= Fetch Seasons =========================
  useEffect(() => {
    const fetchSeasons = async () => {
      try {
        const { totalDocs } = await getSeasonsWithoutLimit(); //para traer el total de temporadas
        if (totalDocs === 0) {
          Notification({
            title: "Aviso",
            text: `Aún no hay temporadas registradas`,
            type: "Info",
          });
          navigate("/home/seasons");
        }
        setTotalSeasons(totalDocs); // Almacenamos el total de temporadas
        IS_LOCAL_ENV && console.log("Se calcularó el número de temporadas");
      } catch (error) {
        IS_LOCAL_ENV && console.error(error);
        setTotalSeasons(0); // En caso de error, no hay temporadas
      }
    };

    // Solo hacer la solicitud si `totalSeasons` es null (lo que significa que aún no hemos hecho la petición)
    if (totalSeasons === null) {
      fetchSeasons();
    }
  }, [totalSeasons, navigate]); // Este useEffect se ejecuta una sola vez cuando el componente se monta.

  // ========================= Set Season Options =========================
  useEffect(() => {
    if (totalSeasons > 0) {
      const opts = [];
      for (let i = 0; i < totalSeasons; i++) {
        opts.push({
          text: `Temporada ${i + 1}`,
          value: i + 1,
        });
      }
      setSeasonOptions(opts); // Configuramos las opciones para el select de temporadas
    }
  }, [totalSeasons]); // Este useEffect depende de `totalSeasons`.

  // ========================= Fetch Season Info =========================
  useEffect(() => {
    const fetchSeasonInfo = async () => {
      if (seasonNumberState <= totalSeasons) {
        try {
          const response = await getSeasonByNumberFiltered(
            seasonNumberState,
            4
          ); // 4 de profundidad
          if (response[0].status === "hidden") {
            Notification({
              title: "Error",
              text: `Temporada ${seasonNumberState} no disponible. Aún no defines los intervalos y fechas de registro`,
              type: "Error",
            });
            return navigate("/home/temporadas");
          }
          const data = fromDate != "" ? filterByDate(response[0]) : response[0];
          setSeasonInfo(data);
          setUpdCount((prev) => prev + 1);
          setLoading(false);
          setLoadingFilter(false);
        } catch (err) {
          IS_LOCAL_ENV && console.error(err);
          Notification({
            title: "Error",
            text: `Algo salió mal...`,
            type: "Error",
          });
        }
      } else {
        Notification({
          title: "Error",
          text: `número de temporada inválido`,
          type: "Error",
        });
        navigate("/home/seasons");
      }
    };

    if (totalSeasons > 0) {
      fetchSeasonInfo(); // Solo hacemos el fetch si tenemos temporadas disponibles
    }
  }, [seasonNumberState, totalSeasons, fromDate]); // Este efecto depende de `seasonNumberState` y `totalSeasons`.

  // ========================= Change Season =========================
  const changeSeason = (e) => {
    navigate(`/home/temporadas/${e.target.value}/programa`);
  };

  const changeQuantity = (blockPos, date, supplieId, newVal) => {
    //testear si hay re-renderizacion
    let temp = { ...seasonInfo };
    temp.blocks[blockPos].blockSDates.map((blockDate) => {
      //if (blockDate.date.split("T")[0] == date) {
      if (blockDate.date == date) {
        blockDate.comsumptions.map((consumption) => {
          if (consumption.supplie.id == supplieId) {
            consumption.quantity = parseInt(newVal);
          }
        });
      }
    });
    setSeasonInfo(temp);
  };

  //===================================filter func============================
  const applyFilters = () => {
    let dt = selectPropsList[0].value;
    if (dt != "") {
      const baseDate = new Date(dt);
      baseDate.setUTCHours(0, 0, 0, 0);
      const utcDate = new Date(baseDate.getTime() + 5 * 60 * 60 * 1000);
      //let utcDate = dt + "T05:00:00.000Z";
      setFromDate(utcDate);
    } else {
      setFromDate("");
    }
  };

  const filterByDate = (data) => {
    const filteredBlocks = data.blocks.map((block) => ({
      ...block,
      blockSDates: block.blockSDates.filter(
        (date) => new Date(date.date) >= fromDate
      ),
    }));
    return { ...data, blocks: filteredBlocks };
  };
  //========================guardar temporada=====================================

  const onClickSaveSeason = () => {
    setSaving(true);
    const handleSaveSeason = async () => {
      try {
        const response = await saveSeason(seasonInfo);
        IS_LOCAL_ENV && console.log(response);
        let temp = { ...seasonInfo };
        temp.status = "published";
        setSeasonInfo(temp);
        setSaving(false);
        setShowModal(false);
        Notification({
          title: "Operación completada",
          text: `${
            seasonInfo.status == "pending"
              ? "Se publicó la nueva temporada"
              : "Se actualizó la temporada"
          }`,
          type: "Success",
        });
      } catch (err) {
        setSaving(false);
        setShowModal(false);
        Notification({
          title: "Error",
          text: `Algo salió mal...`,
          type: "Error",
        });
        IS_LOCAL_ENV && console.error(err);
      }
    };
    handleSaveSeason();
  };

  //const [currentPage, setCurrentPage] = useState(1);
  // const totalPages = 1; //no habrá paginación para esta tabla, no es necesario

  return (
    <>
      <div className="w-full h-full flex flex-col">
        <CommonTitle
          img={purpleFlower}
          title={"Programas de riego"}
          text={
            "Se visualizará el sistema de riego de cada bloque de cada temporada"
          }
        >
          {/* Botón select */}
          {!loading && (
            <Select
              options={seasonOptions}
              initialValue={seasonNumberState}
              setValue={changeSeason}
            />
          )}
        </CommonTitle>
        {loading && (
          <div className="h-full flex items-center">
            <LoadingPage />
          </div>
        )}
        {!loading && (
          <div className="w-full flex flex-col items-center justify-center">
            <Filters applyFilters={applyFilters}>
              {!loadingFilter &&
                selectPropsList.map((props, i) => (
                  <FilterItem props={props} key={i} />
                ))}
            </Filters>
            <TableStructure>
              {seasonNumberState && seasonInfo && (
                <BlockInfoTable
                  data={seasonInfo}
                  changeQuantity={changeQuantity}
                  seasonNumber={seasonNumberState}
                  updCount={updCount}
                />
              )}
            </TableStructure>
            {showModal && (
              <ModalStructure handleCloseModal={() => setShowModal(false)}>
                <div className="flex flex-col items-center justify-center gap-y-4 my-2 font-poppins">
                  <h3 className="font-poppins font-bold text-dark-green text-wrap text-lg">
                    {seasonInfo.status == "pending"
                      ? "Publicar temporada"
                      : "Guardar temporada"}
                  </h3>
                  <span className="text-default-gray w-full text-center px-4 flex">
                    {seasonInfo.status == "pending"
                      ? "Esta acción cambiará el estado de la temporada a published y será visible en la sección de registro de bloques, y no podrá eliminarse. Sin embargo, aún podrás modificar las cantidades en caso lo requieras."
                      : "Esta acción actualizará las cantidades de las fechas programadas de los bloques de la temporada"}
                  </span>

                  <button
                    className={` w-fit  text-lg  flex justify-center rounded-full py-2 px-4 text-white m-2 ${
                      saving
                        ? "bg-default-gray cursor-not-allowed"
                        : "bg-light-purple-600 hover:bg-dark-purple"
                    } transition-all duration-100 font-bold font-poppins `}
                    onClick={onClickSaveSeason}
                    disabled={saving}
                  >
                    <span className="flex flex-row items-center gap-x-2">
                      <span>
                        {seasonInfo.status == "pending"
                          ? "Publicar"
                          : "Guardar"}
                      </span>
                    </span>
                  </button>
                </div>
              </ModalStructure>
            )}
            {seasonInfo && (
              <button
                className={` w-fit mb-4  text-xl  flex justify-center rounded-full py-4 px-8 text-white  ${
                  saving
                    ? "bg-default-gray cursor-not-allowed"
                    : "bg-light-purple-600 hover:bg-dark-purple"
                } transition-all duration-100 font-bold font-poppins `}
                onClick={() => {
                  setShowModal(true);
                }}
                disabled={saving}
              >
                <span className="flex flex-row items-center gap-x-2">
                  <span>
                    {seasonInfo.status == "pending"
                      ? "Publicar temporada"
                      : "Guardar temporada"}
                  </span>
                </span>
              </button>
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default Programs;
